module.exports = __webpack_public_path__ + "6bab57ce7c6f2e8b6e7fbd4863ab970a.png";